export default function TimesheetsUtils(sdk) {
  'ngInject';

  const _utils = sdk('timesheetsUtils');
  Object.assign(this, _utils);
}
